(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5003],{

/***/ 13880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),

/***/ 94640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PictureWithLinkComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82305);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65023);






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var PictureWithLinkComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(PictureWithLinkComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(PictureWithLinkComponent);
    function PictureWithLinkComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, PictureWithLinkComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(args)));
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "onClick", function(e) {
            var _props = _this.props, href = _props.href, src = _props.src;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.PICTURE_WITH_LINK_CLICKED, {
                kind: href,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: src
            });
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(PictureWithLinkComponent, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, href = _this_props.href, target = _this_props.target, otherProps = _object_without_properties(_this_props, [
                    "href",
                    "target"
                ]);
                if (href) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: href,
                        target: target,
                        onClick: this.onClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, otherProps))
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, otherProps));
            }
        }
    ]);
    return PictureWithLinkComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

PictureWithLinkComponent.defaultProps = {
    target: "_self"
};


/***/ }),

/***/ 27190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ withResponsiveHOC; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.scss.js


var StyledResponsiveComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e19xbm3d0"
})(".desktop-wrapper{display:block;}.mobile-wrapper{display:none;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.desktop-wrapper{display:none;}.mobile-wrapper{display:block;}}");

;// CONCATENATED MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



function withResponsiveHOC(DesktopComponent, MobileComponent) {
    return /*#__PURE__*/ function(PureComponent) {
        "use strict";
        (0,_inherits/* default */.Z)(ResponsiveComponent, PureComponent);
        var _super = (0,_create_super/* default */.Z)(ResponsiveComponent);
        function ResponsiveComponent() {
            (0,_class_call_check/* default */.Z)(this, ResponsiveComponent);
            return _super.apply(this, arguments);
        }
        (0,_create_class/* default */.Z)(ResponsiveComponent, [
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledResponsiveComponent, {
                        className: "responsive-hoc-component",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desktop-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopComponent, _object_spread({}, this.props))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileComponent, _object_spread({}, this.props))
                            })
                        ]
                    });
                }
            }
        ]);
        return ResponsiveComponent;
    }(react.PureComponent);
}


/***/ }),

/***/ 28391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ carousel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__(93096);
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/default-props.js
var default_props = __webpack_require__(26687);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/core-components/carousel/slick.scss.js
var slickStyle = '\n  .slick-slider {\n    position: relative;\n    display: block;\n    box-sizing: border-box;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -ms-touch-action: pan-y;\n    touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n  }\n  \n  .slick-loading .slick-slide {\n    visibility: hidden;\n  }\n    \n  .slick-list {\n    position: relative;\n    overflow: hidden;\n    display: block;\n    margin: 0;\n    padding: 0;\n\n    &:focus {\n      outline: none;\n    }\n\n    &.dragging {\n      cursor: pointer;\n      cursor: hand;\n    }\n  }\n  .slick-slider .slick-track,\n  .slick-slider .slick-list {\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  .slick-track {\n    position: relative;\n    left: 0;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n\n    &:before,\n    &:after {\n      content: "";\n      display: table;\n    }\n\n    &:after {\n      clear: both;\n    }\n\n    .slick-loading & {\n      visibility: hidden;\n    }\n  }\n  \n  .slick-slide {\n    float: left;\n    height: 100%;\n    min-height: 1px;\n    [dir="rtl"] & {\n      float: right;\n    }\n    \n    img {\n      display: block;\n    }\n    \n    &.slick-loading img {\n      display: none;\n    }\n\n    display: none;\n\n    &.dragging img {\n      pointer-events: none;\n    }\n\n    & {\n      display: block;\n    }\n\n    .slick-vertical & {\n      display: block;\n      height: auto;\n      border: 1px solid transparent;\n    }\n  }\n  \n  .slick-arrow {\n    &.slick-hidden {\n      display: none;\n    }\n    \n    &.slick-prev,\n    &.slick-next {\n    &:focus-visible {\n        outline: solid 2px #015ecc;\n        border-radius: 4px;\n      }\n    }\n  }\n';

;// CONCATENATED MODULE: ./segments/desktop/core-components/carousel/slick-theme.scss.js
var SLICK_OPACITY_ON_HOVER = 1;
var SLICK_OPACITY_NOT_ACTIVE = 0.25;
var SLICK_OPACITY_DEFAULT = 0.75;
var SLICK_DOT_SIZE = 0.338;
var SLICK_NEXT_CHARACTER = "→";
var SLICK_PREV_CHARACTER = "←";
var SLICK_DOT_CHARACTER = "•";
var slickThemeStyle = '\n  .slick-list {\n    .slick-loading & {\n      background: #fff url("./ajax-loader.gif") center center no-repeat;\n    }\n  }\n\n  .slick-prev,\n  .slick-next {\n    position: absolute;\n    display: block;\n    height: 20px;\n    width: 20px;\n    line-height: 0;\n    font-size: 0;\n    cursor: pointer;\n    background: transparent;\n    color: transparent;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    padding: 0;\n    border: none;\n    outline: none;\n\n    &:hover,\n    &:focus {\n      outline: none;\n      background: transparent;\n      color: transparent;\n\n      &:before {\n        opacity: '.concat(SLICK_OPACITY_ON_HOVER, ";\n      }\n    }\n\n    &.slick-disabled:before {\n      opacity: ").concat(SLICK_OPACITY_NOT_ACTIVE, ";\n    }\n\n    &:before {\n      font-size: 1.125rem;\n      line-height: 1;\n      color: white;\n      opacity: ").concat(SLICK_OPACITY_DEFAULT, ';\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    }\n  }\n\n  .slick-prev {\n    left: -25px;\n\n    [dir="rtl"] & {\n      left: auto;\n      right: -25px;\n    }\n\n    &:before {\n      content: ').concat(SLICK_NEXT_CHARACTER, ';\n\n      [dir="rtl"] & {\n        content: ').concat(SLICK_PREV_CHARACTER, ';\n      }\n    }\n  }\n\n  .slick-next {\n    right: -25px;\n\n    [dir="rtl"] & {\n      left: -25px;\n      right: auto;\n    }\n\n    &:before {\n      content: ').concat(SLICK_PREV_CHARACTER, ';\n\n      [dir="rtl"] & {\n        content: ').concat(SLICK_NEXT_CHARACTER, ";\n      }\n    }\n  }\n\n  .slick-dotted.slick-slider {\n    margin-bottom: 30px;\n  }\n\n  .slick-dots {\n    position: absolute;\n    bottom: -25px;\n    list-style: none;\n    display: block;\n    text-align: center;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n\n    li {\n      position: relative;\n      display: inline-block;\n      height: 20px;\n      width: 20px;\n      margin: 0 5px;\n      padding: 0;\n      cursor: pointer;\n\n      button {\n        border: 0;\n        background: transparent;\n        display: block;\n        height: 20px;\n        width: 20px;\n        outline: none;\n        line-height: 0;\n        font-size: 0;\n        color: transparent;\n        padding: 5px;\n        cursor: pointer;\n\n        &:hover,\n        &:focus {\n          outline: none;\n\n          &:before {\n            opacity: ").concat(SLICK_OPACITY_ON_HOVER, ";\n          }\n        }\n\n        &:before {\n          position: absolute;\n          top: 0;\n          left: 0;\n          content: ").concat(SLICK_DOT_CHARACTER, ";\n          width: 20px;\n          height: 20px;\n          font-size: ").concat(SLICK_DOT_SIZE, ";\n          line-height: 20px;\n          text-align: center;\n          color: black;\n          opacity: ").concat(SLICK_OPACITY_NOT_ACTIVE, ";\n          -webkit-font-smoothing: antialiased;\n          -moz-osx-font-smoothing: grayscale;\n        }\n      }\n\n      &.slick-active button:before {\n        color: black;\n        opacity: ").concat(SLICK_OPACITY_DEFAULT, ";\n      }\n    }\n  }\n");

;// CONCATENATED MODULE: ./segments/desktop/core-components/carousel/carousel.scss.js






var StyledCarousel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "en6i2u80"
})(slickStyle, " ", slickThemeStyle, "  \n  .slick-slider{.slick-dots{z-index:", z_index/* LAYER_ONE */.KW, ";li{margin:0 4px;button{display:inline-block;width:11px;height:11px;border-radius:50%;border:1px solid ", colors/* default.asphalt */.Z.asphalt, ";opacity:1;background-color:transparent;&::before{display:none;}}&.slick-active{button{background-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";border-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}}&:not(.slick-active):hover{button{background-color:#c5c7d0;}}}}}.slick-slider.focus{.slick-list{.slick-track{padding:48px 0;.slick-slide{.carousel-item{outline:none;transition:opacity 0.5s ease,transform 0.5s ease;transform:scale(1);opacity:0.3;}&.slick-active{&.slick-center{.carousel-item{transform:scale(1.175);}}.carousel-item{opacity:1;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/carousel/carousel.js


function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var GO_TO_SPEED_MILLISECONDS = 500;
var GO_TO_ANIMATION_THROTTLE_DELAY = 100;
var PAUSE_AFTER_SWIPE_DELAY = 5000;
var ConditionalWrapper = function(param) {
    var condition = param.condition, wrapper = param.wrapper, children = param.children;
    return condition ? wrapper(children) : children;
};
var Carousel = /*#__PURE__*/ (0,react.forwardRef)(function(props, externalRef) {
    var slider = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(externalRef, function() {
        return {
            scrollToSlide: function scrollToSlide(index) {
                slider === null || slider === void 0 ? void 0 : slider.current.slickGoTo(index);
            },
            pause: function pause() {
                slider === null || slider === void 0 ? void 0 : slider.current.slickPause();
            },
            play: function play() {
                slider === null || slider === void 0 ? void 0 : slider.current.slickPlay();
            },
            next: function next() {
                slider === null || slider === void 0 ? void 0 : slider.current.slickNext();
            },
            prev: function prev() {
                slider === null || slider === void 0 ? void 0 : slider.current.slickPrev();
            }
        };
    }, []);
    // Items props
    var items = props.items, selectedIndex = props.selectedIndex, itemRenderer = props.itemRenderer, onSwipe = props.onSwipe, onChange = props.onChange, itemScale = props.itemScale, lazyLoad = props.lazyLoad;
    // Carousel props
    var autoplay = props.autoplay, autoplaySpeed = props.autoplaySpeed, infinite = props.infinite, slidesToShow = props.slidesToShow, easing = props.easing, arrows = props.arrows, nextArrow = props.nextArrow, prevArrow = props.prevArrow, dots = props.dots, className = props.className, responsive = props.responsive;
    // Advanced carousel props
    var centerMode = props.centerMode, centerPadding = props.centerPadding, defaultIndex = props.defaultIndex, swipeToSlide = props.swipeToSlide, showFocusEffect = props.showFocusEffect, defaultImage = props.defaultImage, carouselClassName = props.carouselClassName, onRefSet = props.onRefSet, focusAfterSwipe = props.focusAfterSwipe, disableSlideOnStartClick = props.disableSlideOnStartClick, speed = props.speed, beforeChange = props.beforeChange, draggable = props.draggable, _slidesToScroll = props.slidesToScroll, slidesToScroll = _slidesToScroll === void 0 ? 1 : _slidesToScroll, _focusOnSelect = props.focusOnSelect, focusOnSelect = _focusOnSelect === void 0 ? true : _focusOnSelect;
    if (!items) return null;
    // Arrange items in right format and order
    var defaultIndexNumber = Math.min(parseInt(defaultIndex), items.length);
    var hasDefault = defaultImage && defaultImage.src;
    var slides = (0,_to_consumable_array/* default */.Z)(items);
    if (hasDefault) {
        slides = (0,_to_consumable_array/* default */.Z)(items.slice(0, defaultIndexNumber)).concat([
            defaultImage
        ], (0,_to_consumable_array/* default */.Z)(items.slice(defaultIndexNumber)));
    }
    var handleSwipe = function(direction) {
        slider.current.slickPause();
        if (autoplay) {
            setTimeout(function() {
                return slider.current.slickPlay();
            }, PAUSE_AFTER_SWIPE_DELAY);
        }
        if (onSwipe) {
            onSwipe(direction);
        }
    };
    var handleChange = function(current) {
        if (onChange) {
            onChange(current);
        }
        if (focusAfterSwipe) {
            var _slider_current_innerSlider_list, _slider_current_innerSlider, _slider_current;
            slider === null || slider === void 0 ? void 0 : (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : (_slider_current_innerSlider = _slider_current.innerSlider) === null || _slider_current_innerSlider === void 0 ? void 0 : (_slider_current_innerSlider_list = _slider_current_innerSlider.list) === null || _slider_current_innerSlider_list === void 0 ? void 0 : _slider_current_innerSlider_list.click();
        }
    };
    var focusSlider = function() {
        var _slider_current_innerSlider, _slider_current;
        if (slider === null || slider === void 0 ? void 0 : (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : (_slider_current_innerSlider = _slider_current.innerSlider) === null || _slider_current_innerSlider === void 0 ? void 0 : _slider_current_innerSlider.list) {
            slider.current.innerSlider.list.setAttribute("tabindex", 0);
            slider.current.innerSlider.list.focus();
        }
    };
    var settings = {
        // Default settings
        className: classnames_default()((0,_define_property/* default */.Z)({
            center: centerMode,
            focus: showFocusEffect
        }, className, className)),
        speed: speed || GO_TO_SPEED_MILLISECONDS,
        dots: dots,
        focusOnSelect: focusOnSelect,
        onSwipe: handleSwipe,
        afterChange: handleChange,
        beforeChange: beforeChange,
        // User props
        infinite: infinite,
        slidesToScroll: slidesToScroll,
        arrows: arrows,
        nextArrow: nextArrow,
        prevArrow: prevArrow,
        swipeToSlide: swipeToSlide,
        slidesToShow: Math.min(slidesToShow, slides.length),
        centerPadding: centerPadding,
        easing: easing,
        centerMode: centerMode,
        autoplay: autoplay,
        autoplaySpeed: parseInt(autoplaySpeed),
        lazyLoad: lazyLoad,
        draggable: draggable
    };
    var onIndexChanged = function(selectedIndex) {
        var newIndex;
        if (selectedIndex !== null && centerMode) {
            newIndex = selectedIndex >= defaultIndexNumber && hasDefault ? selectedIndex + 1 : selectedIndex;
        } else {
            newIndex = defaultIndexNumber;
        }
        slider.current.slickGoTo(newIndex);
    };
    // Throttle and give some delay (100ms) because when the index changes
    // `slickGoTo` does not work properly when changing fast
    var throttledOnIndexChanged = (0,react.useCallback)(lodash_throttle_default()(onIndexChanged, GO_TO_SPEED_MILLISECONDS + GO_TO_ANIMATION_THROTTLE_DELAY, {
        trailing: true
    }), []);
    (0,react.useEffect)(function() {
        throttledOnIndexChanged(selectedIndex);
    }, [
        selectedIndex
    ]);
    (0,react.useEffect)(function() {
        if (slider === null || slider === void 0 ? void 0 : slider.current) {
            if (onRefSet) {
                onRefSet(slider.current);
            }
        }
    }, [
        slider
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarousel, {
        className: classnames_default()("carousel", carouselClassName),
        onTouchStart: disableSlideOnStartClick ? null : focusSlider,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, _object_spread_props(_object_spread({
            ref: slider
        }, settings), {
            initialSlide: defaultIndexNumber,
            responsive: responsive,
            children: slides.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "carousel-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper, {
                        condition: itemScale != 1,
                        wrapper: function(children) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    transform: "scale(".concat(itemScale, ")")
                                },
                                children: children
                            });
                        },
                        children: itemRenderer(item, index)
                    })
                }, "slide_".concat(index));
            })
        }))
    });
});
Carousel.defaultProps = default_props/* default */.Z;
/* harmony default export */ var carousel = (Carousel);


/***/ }),

/***/ 26687:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    infinite: true,
    arrows: false,
    autoplay: false,
    defaultIndex: 2,
    slidesToShow: 3,
    easing: "cubic",
    itemScale: 1,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: "10%",
    swipeToSlide: true,
    showFocusEffect: true,
    pauseOnFocus: true,
    lazyLoad: false,
    dots: false,
    reducedVerticalPadding: false // TODO: barben i don't know if the current 48px you added in the css is a must, but it's much more then i need
});


/***/ }),

/***/ 69737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ badges_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/badges-grid/badges-const.js
var badges_const = __webpack_require__(25627);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./components/core/images-gallery/images-gallery-row/images-gallery-row-component.js + 3 modules
var images_gallery_row_component = __webpack_require__(99112);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/badges-grid/default-props.js
var default_props = __webpack_require__(26455);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/components/badges-grid-desktop/badges-grid-desktop-component.scss.js



var StyledBadgesGridDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1duxf0w0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;padding-right:", function(param) {
    var horizontalPadding = param.horizontalPadding;
    return horizontalPadding || default_props/* default.horizontalPadding */.Z.horizontalPadding;
}, ";padding-left:", function(param) {
    var horizontalPadding = param.horizontalPadding;
    return horizontalPadding || default_props/* default.horizontalPadding */.Z.horizontalPadding;
}, ";.images-gallery-row{flex-wrap:nowrap;gap:12px;.image-gallery{.picture-component{img{min-width:72px;width:100%;height:100%;object-fit:contain;max-width:120px;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/components/badges-grid-desktop/badges-grid-desktop-component.js



var BadgesGridDesktopComponent = function(param) {
    var badges = param.badges, horizontalPadding = param.horizontalPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadgesGridDesktopComponent, {
        horizontalPadding: horizontalPadding,
        className: "badges-grid-desktop-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_gallery_row_component/* default */.Z, {
            assets: badges
        })
    });
};
/* harmony default export */ var badges_grid_desktop_component = (BadgesGridDesktopComponent);

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/components/badges-grid-mobile/badges-grid-mobile-component.scss.js

var StyledBadgesGridMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehaikjk0"
})(".badge-wrapper{padding:8px;}.slick-list{padding:0 20% 0;.slick-track{.slick-slide{.picture-component{img{width:100%;height:100%;object-fit:contain;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/components/badges-grid-mobile/badges-grid-mobile-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var BadgesGridMobileComponent = function(param) {
    var badges = param.badges;
    var itemRenderer = function(param) {
        var url = param.url, name = param.name;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "badge-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                src: url,
                alt: name
            })
        });
    };
    var carouselProps = {
        items: badges,
        itemRenderer: itemRenderer,
        defaultIndex: Math.floor(badges.length / 2),
        infinite: false,
        centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 1
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadgesGridMobileComponent, {
        className: "badges-grid-mobile-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, _object_spread({}, carouselProps))
    });
};
/* harmony default export */ var badges_grid_mobile_component = (BadgesGridMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/badges-grid-component.js







var BadgesGridComponent = function(param) {
    var product = param.product, country = param.country, horizontalPadding = param.horizontalPadding;
    var badges = (0,react.useMemo)(function() {
        var _BADGES_PER_PRODUCT_BY_COUNTRY_product, _BADGES_PER_PRODUCT_BY_COUNTRY_product1;
        return ((_BADGES_PER_PRODUCT_BY_COUNTRY_product = badges_const/* BADGES_PER_PRODUCT_BY_COUNTRY */.M[product]) === null || _BADGES_PER_PRODUCT_BY_COUNTRY_product === void 0 ? void 0 : _BADGES_PER_PRODUCT_BY_COUNTRY_product[country]) || ((_BADGES_PER_PRODUCT_BY_COUNTRY_product1 = badges_const/* BADGES_PER_PRODUCT_BY_COUNTRY */.M[product]) === null || _BADGES_PER_PRODUCT_BY_COUNTRY_product1 === void 0 ? void 0 : _BADGES_PER_PRODUCT_BY_COUNTRY_product1[badges_const/* BADGES_COUNTRIES.GENERAL */.W.GENERAL]) || badges_const/* BADGES_PER_PRODUCT_BY_COUNTRY */.M[products/* WORK_MANAGEMENT_PRODUCT_ID */.py][badges_const/* BADGES_COUNTRIES.GENERAL */.W.GENERAL];
    }, [
        product
    ]);
    var BadgesResponsiveComponent = (0,react.useMemo)(function() {
        return (0,responsive_hoc_component/* default */.Z)(badges_grid_desktop_component, badges_grid_mobile_component);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgesResponsiveComponent, {
        badges: badges,
        horizontalPadding: horizontalPadding
    });
};
/* harmony default export */ var badges_grid_component = (BadgesGridComponent);


/***/ }),

/***/ 42057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES = (__webpack_require__(72632).COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES);
var CLOUDFRONT_MOBILE_HEADER = "cloudfront-is-mobile-viewer";
var CLOUDFRONT_TABLET_HEADER = "cloudfront-is-tablet-viewer";
var CLOUDFRONT_DESKTOP_HEADER = "cloudfront-is-desktop-viewer";
var CLOUDFRONT_COUNTRY_HEADER = "cloudfront-viewer-country";
var isMobileOrTablet = function(req) {
    return isMobile(req) || isTablet(req);
};
var isMobile = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_MOBILE_HEADER] && headers[CLOUDFRONT_MOBILE_HEADER] === "true";
};
var isTablet = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_TABLET_HEADER] && headers[CLOUDFRONT_TABLET_HEADER] === "true";
};
var isDesktop = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_DESKTOP_HEADER] && headers[CLOUDFRONT_DESKTOP_HEADER] === "true";
};
var isCookiesPolicyRequiredCountryFromServer = function(res) {
    var cloudFrontCountry = res.getHeader(CLOUDFRONT_COUNTRY_HEADER);
    return doesCountryRequireStrictCookiePolicy(cloudFrontCountry);
};
var doesCountryRequireStrictCookiePolicy = function(cloudFrontCountry) {
    return cloudFrontCountry && COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES.includes(cloudFrontCountry);
};
module.exports = {
    isMobileOrTablet: isMobileOrTablet,
    isDesktop: isDesktop,
    isMobile: isMobile,
    isTablet: isTablet,
    isCookiesPolicyRequiredCountryFromServer: isCookiesPolicyRequiredCountryFromServer,
    doesCountryRequireStrictCookiePolicy: doesCountryRequireStrictCookiePolicy
};


/***/ }),

/***/ 77784:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref = __webpack_require__(85010), isCountryInContinent = ref.isCountryInContinent, OCEANIA = ref.OCEANIA;
var ref1 = __webpack_require__(13019), USE_OLD_STORAGE_SETTINGS = ref1.USE_OLD_STORAGE_SETTINGS, WEBSITE_AB_TEST_DEBUG_COOKIE_NAME = ref1.WEBSITE_AB_TEST_DEBUG_COOKIE_NAME;
var getAbTestVariantNew = (__webpack_require__(41871).getAbTestVariantNew);
var doesCountryRequireStrictCookiePolicy = (__webpack_require__(42057).doesCountryRequireStrictCookiePolicy);
var isRunningInClient = (__webpack_require__(44566).isRunningInClient);
var ref2 = __webpack_require__(60734), SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST = ref2.SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST, EXIT_POP_UP_SURVEY_AB_TEST = ref2.EXIT_POP_UP_SURVEY_AB_TEST, REVIVE_EXIT_POPUP_AB_TEST = ref2.REVIVE_EXIT_POPUP_AB_TEST, PERFORMANCE_STATIC_PAGE_AB_TEST = ref2.PERFORMANCE_STATIC_PAGE_AB_TEST, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES = ref2.BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES, DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST = ref2.DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST, PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST = ref2.PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST, MOBILE_STICKY_SIGNUP_AB_TEST = ref2.MOBILE_STICKY_SIGNUP_AB_TEST, WELCOME_BACK_PAGE_TEST = ref2.WELCOME_BACK_PAGE_TEST, KEEP_REGION_TEST = ref2.KEEP_REGION_TEST, CONTACT_SALES_TYPEFORM_EMEA = ref2.CONTACT_SALES_TYPEFORM_EMEA, CONTACT_SALES_TYPEFORM_ANZ = ref2.CONTACT_SALES_TYPEFORM_ANZ, HEADER_NEW_PRODUCTS_OFFERING_TEST = ref2.HEADER_NEW_PRODUCTS_OFFERING_TEST, UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST = ref2.UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST, TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST = ref2.TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST, STUDIO_IN_HEADER_TEST = ref2.STUDIO_IN_HEADER_TEST, ENHANCED_PRODUCTS_IN_HEADER_TEST = ref2.ENHANCED_PRODUCTS_IN_HEADER_TEST, WM_HIGH_INTENT_EXPERIENCE = ref2.WM_HIGH_INTENT_EXPERIENCE, CONTACT_SALES_FOOTER_TEST = ref2.CONTACT_SALES_FOOTER_TEST, BOOK_A_MEETING_EMAIL_TEST = ref2.BOOK_A_MEETING_EMAIL_TEST, CX_BOT_TEST = ref2.CX_BOT_TEST, ENTERPRISE_BUTTON_IN_HEADER_TEST = ref2.ENTERPRISE_BUTTON_IN_HEADER_TEST, GET_QUOTE_TEXT_IN_PRICING = ref2.GET_QUOTE_TEXT_IN_PRICING;
var shouldGetSkipSignUpStepInPricingAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST, sendBigBrainEvent) === "new_with_skip";
};
var shouldSeeExitPopupSurveyAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 ? arguments[1] : void 0;
    return getAbTestVariantNew(abTests, EXIT_POP_UP_SURVEY_AB_TEST, sendBigBrainEvent) === "new_with_survey";
};
var shouldSeeReviveExitPopupAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, REVIVE_EXIT_POPUP_AB_TEST.test_name, sendBigBrainEvent) === REVIVE_EXIT_POPUP_AB_TEST.new_variation_name;
};
var shouldSeeStaticPagePerformanceAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cloudfrontViewerCountry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (doesCountryRequireStrictCookiePolicy(cloudfrontViewerCountry)) return false;
    return getAbTestVariantNew(abTests, PERFORMANCE_STATIC_PAGE_AB_TEST.test_name, sendBigBrainEvent) === PERFORMANCE_STATIC_PAGE_AB_TEST.new_variation_name;
};
var shouldShowBiggerStorageInPricingFeatures = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cookies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof cookies[USE_OLD_STORAGE_SETTINGS] !== "undefined") {
        return cookies[USE_OLD_STORAGE_SETTINGS] !== "true";
    }
    return getAbTestVariantNew(abTests, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.test_name, sendBigBrainEvent) === BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.new_variation_name;
};
var shouldSeeDesktopWithEnterpriseMenuAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.test_name, sendBigBrainEvent) === DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.new_variation_name;
};
var shouldGetEnterpriseContactUsPageAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST.test_name, sendBigBrainEvent) === PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST.new_variation_name;
};
var shouldGetMobileStickySignupAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, MOBILE_STICKY_SIGNUP_AB_TEST.test_name, sendBigBrainEvent) === MOBILE_STICKY_SIGNUP_AB_TEST.new_variation_name;
};
var shouldGetWelcomeBackPageTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], persistantCookies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, extraBigBrainParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (persistantCookies[WEBSITE_AB_TEST_DEBUG_COOKIE_NAME] === WELCOME_BACK_PAGE_TEST.test_name) return true;
    return getAbTestVariantNew(abTests, WELCOME_BACK_PAGE_TEST.test_name, sendBigBrainEvent, false, extraBigBrainParams) === WELCOME_BACK_PAGE_TEST.new_variation_name;
};
var shouldGetKeepRegionTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cloudfrontViewerCountry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    try {
        var _localStorage;
        if (isRunningInClient() && ((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem("is_in_keep_region_test")) === "true") {
            return true;
        }
        if (isCountryInContinent(cloudfrontViewerCountry, OCEANIA)) {
            // only people from Oceanic countries should enter the test
            return getAbTestVariantNew(abTests, KEEP_REGION_TEST.test_name, sendBigBrainEvent) === KEEP_REGION_TEST.new_variation_name;
        }
    } catch (error) {
    // nothing to do - just done to protect from crashes
    }
    return false;
};
var shouldGetContactSalesTypeformEmeaTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_TYPEFORM_EMEA.test_name, sendBigBrainEvent) === CONTACT_SALES_TYPEFORM_EMEA.new_variation_name;
};
var shouldGetContactSalesTypeformAnzTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_TYPEFORM_ANZ.test_name, sendBigBrainEvent) === CONTACT_SALES_TYPEFORM_ANZ.new_variation_name;
};
var shouldHaveHeaderWithNewProductsOfferingTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, HEADER_NEW_PRODUCTS_OFFERING_TEST.test_name, sendBigBrainEvent) === HEADER_NEW_PRODUCTS_OFFERING_TEST.new_variation_name;
};
var shouldGetUnlimitedTimeCTATextTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST.test_name, sendBigBrainEvent) === UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST.new_variation_name;
};
var shouldUseNewTypeformVariant = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST.test_name, sendBigBrainEvent) === TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST.new_variation_name;
};
var shouldHaveStudioProductInHeaderTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, STUDIO_IN_HEADER_TEST.test_name, sendBigBrainEvent) === STUDIO_IN_HEADER_TEST.new_variation_name;
};
var shouldHaveEnhancedProductsInHeaderTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, ENHANCED_PRODUCTS_IN_HEADER_TEST.test_name, sendBigBrainEvent) === ENHANCED_PRODUCTS_IN_HEADER_TEST.new_variation_name;
};
var shouldGetWMHighIntentExperience = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, WM_HIGH_INTENT_EXPERIENCE.test_name, sendBigBrainEvent) === WM_HIGH_INTENT_EXPERIENCE.new_variation_name;
};
var shouldGetContactSalesInTheFooter = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_FOOTER_TEST.test_name, sendBigBrainEvent) === CONTACT_SALES_FOOTER_TEST.new_variation_name;
};
var shouldSendBookAMeetingEmail = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, BOOK_A_MEETING_EMAIL_TEST.test_name, sendBigBrainEvent) === BOOK_A_MEETING_EMAIL_TEST.new_variation_name;
};
var shouldGetEnterpriseButtonInHeader = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, ENTERPRISE_BUTTON_IN_HEADER_TEST.test_name, sendBigBrainEvent) === ENTERPRISE_BUTTON_IN_HEADER_TEST.new_variation_name;
};
var shouldOpenCXBot = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CX_BOT_TEST.test_name, sendBigBrainEvent) === CX_BOT_TEST.new_variation_name;
};
var shouldGetQuoteTextInPricing = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, GET_QUOTE_TEXT_IN_PRICING.test_name, sendBigBrainEvent) === GET_QUOTE_TEXT_IN_PRICING.new_variation_name;
};
module.exports = {
    shouldGetSkipSignUpStepInPricingAbTest: shouldGetSkipSignUpStepInPricingAbTest,
    shouldSeeExitPopupSurveyAbTest: shouldSeeExitPopupSurveyAbTest,
    shouldSeeReviveExitPopupAbTest: shouldSeeReviveExitPopupAbTest,
    shouldSeeStaticPagePerformanceAbTest: shouldSeeStaticPagePerformanceAbTest,
    shouldShowBiggerStorageInPricingFeatures: shouldShowBiggerStorageInPricingFeatures,
    shouldSeeDesktopWithEnterpriseMenuAbTest: shouldSeeDesktopWithEnterpriseMenuAbTest,
    shouldGetEnterpriseContactUsPageAbTest: shouldGetEnterpriseContactUsPageAbTest,
    shouldGetMobileStickySignupAbTest: shouldGetMobileStickySignupAbTest,
    shouldGetWelcomeBackPageTest: shouldGetWelcomeBackPageTest,
    shouldGetKeepRegionTest: shouldGetKeepRegionTest,
    shouldGetContactSalesTypeformEmeaTest: shouldGetContactSalesTypeformEmeaTest,
    shouldGetContactSalesTypeformAnzTest: shouldGetContactSalesTypeformAnzTest,
    shouldHaveHeaderWithNewProductsOfferingTest: shouldHaveHeaderWithNewProductsOfferingTest,
    shouldGetUnlimitedTimeCTATextTest: shouldGetUnlimitedTimeCTATextTest,
    shouldUseNewTypeformVariant: shouldUseNewTypeformVariant,
    shouldHaveStudioProductInHeaderTest: shouldHaveStudioProductInHeaderTest,
    shouldHaveEnhancedProductsInHeaderTest: shouldHaveEnhancedProductsInHeaderTest,
    shouldGetWMHighIntentExperience: shouldGetWMHighIntentExperience,
    shouldGetContactSalesInTheFooter: shouldGetContactSalesInTheFooter,
    shouldSendBookAMeetingEmail: shouldSendBookAMeetingEmail,
    shouldOpenCXBot: shouldOpenCXBot,
    shouldGetEnterpriseButtonInHeader: shouldGetEnterpriseButtonInHeader,
    shouldGetQuoteTextInPricing: shouldGetQuoteTextInPricing
};


/***/ })

}]);